import { localizePageUrl } from 'i18n/urlLocale';

// Full page loads and new windows for a page on this site, with the current
// page's locale prefix, so /ja/... stays in Japanese (docs/i18n.md,
// "Locale-prefixed URLs"). Other sites and files are opened as given. For
// link-like navigation that may load in place, use visit() from
// navigation/clientNavigation.

export function assignPage(url, rootWindow = window) {
	rootWindow.location.assign(localizePageUrl(url, rootWindow));
}

export function openPage(url, target, features, rootWindow = window) {
	return rootWindow.open(localizePageUrl(url, rootWindow), target, features);
}
